import React, { useEffect, useState } from "react";
import { getEventsinner } from '../Service/Api';
import Header from '../Component/Header'
import { Link } from 'react-router-dom' 
import LazyLoad from 'react-lazyload';
import Footer from'../Component/Footer'
const Events = () => {
     useEffect(() => {
        document.title = 'Events -  St Peters convent School Faridabad Haryana';  
    }, []); 
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    const currentMonthName = monthNames[currentMonth];
    
    const [data, setData] = useState([]);
    const [filterData, setFilteredData] = useState([]);
    const [selectedYear, setSelectedYear] = useState(`${currentYear}`);
    const [selectedMonth, setSelectedMonth] = useState(currentMonthName);
    const [yearRanges, setYearRanges] = useState([]);
    const [monthOptions, setMonthOptions] = useState(["All"]);
    const [searchQuery, setSearchQuery] = useState("");
    
    useEffect(() => {
        const fetchData = async () => {
            const galleryData = await getEventsinner(); 
            setData(galleryData);
    
            // Get unique years from events (sorted in ascending order)
            const uniqueYears = Array.from(new Set(galleryData.map((item) => item.date ? new Date(item.date).getFullYear() : null).filter(Boolean)));
            if (!uniqueYears.includes(currentYear)) {
                uniqueYears.push(currentYear);
            }
            uniqueYears.sort((a, b) => a - b);
            setYearRanges(["All", ...uniqueYears.map(year => `${year}`)]);
    
            // Get unique months
            const uniqueMonths = Array.from(new Set(galleryData.map((item) => item.date ? new Date(item.date).getMonth() : null).filter(Boolean)));
            if (!uniqueMonths.includes(currentMonth)) {
                uniqueMonths.push(currentMonth);
            }
            const sortedMonths = uniqueMonths.sort((a, b) => a - b).map(month => monthNames[month]);
            setMonthOptions(["All", ...sortedMonths]);
        };
        fetchData();
    }, []);
    
    useEffect(() => {
        let filteredData = [...data].filter(
            (item) =>
                typeof item.title === "string" &&
                item.title.trim().length > 0 &&
                typeof item.description === "string" &&
                item.description.trim().length > 0
        );
    
        // Filter by selected year
        if (selectedYear !== "All") {
            filteredData = filteredData.filter((item) => {
                if (item.date) {
                    const year = new Date(item.date).getFullYear();
                    return parseInt(selectedYear) === year;
                }
                return false;
            });
        }
    
        // Filter by selected month
        if (selectedMonth !== "All") {
            filteredData = filteredData.filter((item) => {
                if (item.date) {
                    const month = new Date(item.date).getMonth();
                    return monthNames[month] === selectedMonth;
                }
                return false;
            });
        }
    
        // Search filter
        if (searchQuery) {
            filteredData = filteredData.filter((item) =>
                item.title.toLowerCase().includes(searchQuery.toLowerCase())
            );
        }
    
        // Separate current month events from others
        const currentMonthEvents = filteredData.filter((item) => {
            if (item.date) {
                const eventDate = new Date(item.date);
                return eventDate.getFullYear() === currentYear && eventDate.getMonth() === currentMonth;
            }
            return false;
        });
    
        // Remaining events sorted in ascending order (earliest events first)
        const otherEvents = filteredData.filter((item) => !currentMonthEvents.includes(item));
        otherEvents.sort((a, b) => new Date(b.date) - new Date(a.date));
    
        // Combine: Current month events first, then all others in ascending order
        setFilteredData([...currentMonthEvents, ...otherEvents]);
    }, [data, selectedYear, selectedMonth, searchQuery]);
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li>  
     <li>Events </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>Events  </h1>
         </div>
     </div>
     <div className="row tabs-dynamic">
     <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
         <div className="count-val">
             <p>Total Count: {filterData.length} </p>
         </div>
     </div>
     <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
         <div className="month-selection">
             <select
                 value={selectedYear}
                 onChange={(e) => setSelectedYear(e.target.value)}
                 className="yearSelection">
                 
                 {yearRanges.map((yr) => (
                     <option key={yr} value={yr}>{yr}</option>
                 ))}
             </select>
         </div>
     </div>
     <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
         <div className="month-selection">
             <select
                 value={selectedMonth}
                 onChange={(e) => setSelectedMonth(e.target.value)}
                 className="monthSelect">
                 {monthOptions.map((month, index) => (
                     <option key={index} value={month}>{month}</option>
                 ))}
             </select>
         </div>
     </div>
     <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
         <div className="searchBox">
             <input
                 type="text"
                 id="myInput"
                 name="name"
                 value={searchQuery}
                 onChange={(e) => setSearchQuery(e.target.value)}
                 placeholder="Search Here.."
             />
         </div>
     </div>
 </div>
 <div className="row years year2023 showYear">
     {filterData.length > 0 &&
         filterData.map((item, index) => (
             <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 eventCount" key={index}>
                 <div className="eventbox">
                     <div className="eventboximg">
                     {item.attachments && item.attachments.length > 0 && (
                         <div className="eventattch">
                         <Link to={`https://webapi.entab.info/api/image/${item?.attachments}`} target="_blank">
                             <i className="bi bi-paperclip"></i>
                         </Link>
                     </div>
                     )}
                     <LazyLoad>
                     {item?.images.length > 0 ? (
                       <a
                         data-magnify="gallery"
                         data-src={`https://webapi.entab.info/api/image/${item.images[0]}`}
                         data-group="a"
                         href={`https://webapi.entab.info/api/image/${item.images[0]}`}
                       >
                         <img
                           src={`https://webapi.entab.info/api/image/${item.images[0]}`}
                           alt="Gallery"
                           className="img-fluid"
                         />
                       </a>
                     ) : (
                       <a
                         data-magnify="gallery"
                         data-src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/events.jpg"
                         data-group="a"
                         href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/events.jpg"
                       >
                         <img
                           src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/events.jpg"
                           alt="Gallery Placeholder"
                           className="img-fluid"
                         />
                       </a>
                     )}
                   </LazyLoad>   </div>
                     <div className="eventboxdesc">
                         <div className="eventpgh">
                             <h5>{item.title}</h5>
                             <p>{item.description}</p>
                         </div>
                         <div className="eventdate">
                         <span><i className="bi bi-calendar"></i> {item.date}</span>
                             <span><i className="bi bi-alarm"></i>{item.time}</span>
                             
                             <span><i className="bi bi-geo-alt"></i> {item.venue} </span>
                         </div>
                     </div>
                 </div>
             </div>
         ))}
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default Events
